<!--
{
  "type": "features",
  "data": {
    "title": "",
    "description": "",
    "layout": "image-title-description-button" | "quote",
    "layoutprops": {
      "aspect": "16-10" | "16-9" | "3-2" | "4-3" | "3-4" | "1-1" | "fluid",
      "imageTint": 15",
      "cardOverlayStyle": "text-overlay-card" | "text-overlay-gradient" | ""
    },
    "columns": 2,
    "items": [
      {
        "title": "",
        "description": "",
        "button": {
          "url": "",
          "title": ""
        },
        "icon": {
          "filestorename": "website",
          "filepath": "/path/to/file",
          "data" {
            "title": "",
            "alt": ""
          }
        }
      }
      ...
    ]
  }
}
-->
<template>
  <b-container>
    <b-row v-if="title">
      <b-col><h3>{{ title }}</h3></b-col>
    </b-row>
    <b-row v-if="description">
      <b-col
        class="description"
        v-html="description"
      />
    </b-row>
    <b-row>
      <b-col>
        <sp-feature-feature
          :features-style="featuresStyle"
          :features-layout="featuresLayout"
          :layout-props="featuresLayoutProps"
          :features="features"
          :constructed="true"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'slice-type-features',
  props: {
    slice: {
      type: Object,
      required: false,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    data() {
      return this.slice.data
    },
    featuresStyle() {
      return `${this.data.columns}col`
    },
    featuresLayout() {
      return this.data.layout
    },
    featuresLayoutProps() {
      return this.data.layoutProps ?? {}
    },
    title() {
      return this.data.title
    },
    description() {
      return this.data.description
    },
    features() {
      return this.data.items
    }
  }
}
</script>

<style scoped lang="scss">
  h3, .description {
    text-align: center;
  }
</style>
